/* @flow */
import Fieldset from 'components/Fieldset';
import Group from 'entities/Group';
import PropTypes from 'prop-types';
import * as React from 'react';
import RelationshipViewGroupListItem from 'user/components/RelationshipViewGroupListItem';
import Subscriber from 'entities/Subscriber';
import Subscription from 'entities/Subscription';

class RelationshipViewGroupList extends React.Component<$FlowFixMeProps> {
  static propTypes = {
    legend: PropTypes.string.isRequired,
    groupSubscriptions: PropTypes.arrayOf(
      PropTypes.shape({
        group: PropTypes.instanceOf(Group).isRequired,
        subscription: PropTypes.instanceOf(Subscription), // to the group
      })
    ).isRequired,
  };

  static contextTypes = {
    subscriber: PropTypes.instanceOf(Subscriber).isRequired,
  };

  render() {
    return (
      <Fieldset legend={this.props.legend} size="small">
        {this.props.groupSubscriptions.map(({ group, subscription }) => (
          <RelationshipViewGroupListItem
            key={group.id}
            group={group}
            subscriber={this.context.subscriber}
            subscription={subscription}
          />
        ))}
        {this.props.children}
      </Fieldset>
    );
  }
}

export default RelationshipViewGroupList;
